import { indexData } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            专题合集
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">热门专题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">精选深度专题报道，一站式了解各类话题全貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {indexData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute bottom-2 right-2 px-2.5 py-1 bg-foreground-950/70 text-background-50 text-[10px] rounded whitespace-nowrap">
                  {item.count}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}